import SignIn from './pages/login/login'
import React from 'react'

export default function Public() {
  return (
    <SignIn/>
  )
}
